import React from "react";
import Grid from "@material-ui/core/Grid";
import goldCoin from "../../../../assets/images/ic_coin.png";
import silverCoin from "../../../../assets/images/ic_silver_coin.png";
class Video extends React.Component{
    constructor() {
        super();
    }
    render() {
        const {
            icon,
            firstLayerColor,
            text,
            secondLayerColor,
            thirdLayerColor,
            topLayerBackgroundColor
        }
            =this.props.data
        const videosInQueue=[
            {
                coinType:'gold',
                quantity:'5',
                icon:goldCoin
            },
            {
                coinType:'gold',
                quantity:'5',
                icon: silverCoin
            },{
                coinType:'silver',
                quantity:'5',
                icon:goldCoin

            },{
                coinType:'gold',
                quantity:'5',
                icon: silverCoin
            },{
                coinType:'gold',
                quantity:'5',
                icon:goldCoin

            },,{
                coinType:'gold',
                quantity:'5',
                icon: silverCoin

            },
        ]
        return(
            <Grid justify={'center'} className='item-holder' xs={12} sm={12}  item container
                  style={{backgroundColor:firstLayerColor}}>
                <Grid alignItems={"center"} justify={"center"} xs={12} sm={12} item container className='item-holder-first-layer'
                      style={{backgroundColor:secondLayerColor}}>
                    <Grid sm={12} xs={12} alignItems={"flex-start"} justify={"center"} item container
                          className='item-holder-first-layer-second-layer invitation-top-overlay'
                          style={{backgroundColor:topLayerBackgroundColor,marginBottom:'10px',height:'auto'}}>
                        <Grid justify={"space-between"} alignItems={"center"} item container className='video-top-section' style={{margin:'0 50px',padding:'0 10px'}}>
                            <Grid sm={11} xs={11} item style={{position:'relative'}}>
                                <p>
                                    {text}
                                </p>
                            </Grid>
                            <img src={icon} className='video-top-section-icon' alt=""/>
                        </Grid>
                        <Grid  justify={"space-around"} item container style={{marginTop:'5px'}}>
                        </Grid>
                    </Grid>
                    <Grid sm={12} xs={12} justify={"center"} alignItems={"center"} item container
                          className='item-holder-first-layer-second-layer invitation-bottom-overlay'
                          style={{backgroundColor:thirdLayerColor}}>
                        <Grid container sm={11} xs={11} alignItems={"center"} justify={"center"} className='videos-in-queue' item style={{
                            padding:'0px 10px',
                            // height:'80px'
                        }}>
                            {
                                videosInQueue.map(data=>{
                                    return(<Grid item sm={2} xs={2} container alignItems={"center"}
                                    >
                                        <Grid container alignItems={"center"} item style={{
                                            marginTop:'20px',
                                            width:'100%',height:'5px',backgroundColor:'#ffffff',position:'relative'}}>
                                            <Grid style={{backgroundColor:'#ffffff',border:'1px solid black',borderRadius:'50%',position:'absolute',
                                                width:'30%',
                                                height:'400%',
                                                right:'0',
                                            }}>
                                            </Grid>
                                        </Grid>
                                    </Grid>)
                                })
                            }
                            {
                                videosInQueue.map(data=>{
                                    return(<Grid item sm={2} xs={2} container alignItems={"center"}
                                    >
                                        <Grid container justify={"flex-end"} alignItems={"center"} item style={{position:'relative',
                                            marginTop:'10px',
                                        }}>
                                            <p style={{padding:'0 5px'}}>{data.quantity}</p>
                                            <img src={data.icon} style={{width:'25%'}} alt=""/>
                                        </Grid>
                                    </Grid>)
                                })
                            }




                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

}
export  default Video